import request from 'crm/utils/request'
import api from 'crm/common/api/company-moments'
import {format} from 'utils/index'
import {stringify} from 'qs'

// 朋友圈列表
export async function getMoments(params) {
    return request(`${api.getMoments.url}?${stringify(params)}`)
}

export async function deleteMoment(payload) {
    return request(format(`${api.deleteMoment.url}`, {id: payload.id}), {
        method: api.deleteMoment.type,
    })
}

export async function getMomentDetails(payload) {
    return request(format(`${api.getMomentDetails.url}`, {id: payload.id}))
}

export async function editMoment(payload) {
    return request(format(`${api.editMoment.url}`, {id: payload.id}), {
        method: api.editMoment.type,
        body: payload.body,
    })
}

// 创建朋友圈
export async function createMoment(payload) {
    return request(format(`${api.createMoment.url}`), {
        method: api.createMoment.type,
        body: payload.body,
    })
}

// 获取朋友圈参数
export async function getMomentsParams() {
    return request(api.getMomentsParams.url)
}

// 设置朋友圈参数
export async function editMomentsParams(payload) {
    return request(format(`${api.editMomentsParams.url}`), {
        method: api.editMomentsParams.type,
        body: payload.body,
    })
}
